module.exports = __webpack_public_path__ + "static/img/zlan.c4a9fa4d.png";